/**
 * Se encarga de procesar un report y autogestionar
 * los items y la columns del cual se requiere del datalle.
 *
 * @param {Object}  Reporte a procesar.
 * @param {Object} Objecto que contiene las columns mapeadas.
 * @return {Object}
 */
export const helperGetColumsItems = (report, mapColumns) => {
  let items = [];
  let columns = [];

  const keys = Object.keys(report);
  keys.forEach((key) => {
    const itemsR = report[key];
    if (typeof itemsR === "object" && itemsR !== null) {
      items = itemsR;
      columns = mapColumns[key];
    }
  });

  return { items, columns };
};
